/* Minimal inline brand glyphs (monochrome-friendly) for marketing mockups. */

export function FacebookGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#1877F2" d="M24 12a12 12 0 1 0-13.9 11.9v-8.4H7v-3.5h3.1V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v3h-1.5c-1.5 0-2 .9-2 1.9v2.2h3.4l-.5 3.5h-2.9v8.4A12 12 0 0 0 24 12z" />
    </svg>
  );
}

export function InstagramGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <radialGradient id="igg" cx="30%" cy="107%" r="130%">
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="75%" stopColor="#d6249f" />
          <stop offset="100%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#igg)" />
      <circle cx="12" cy="12" r="4.3" fill="none" stroke="#fff" strokeWidth="1.7" />
      <circle cx="17.2" cy="6.8" r="1.2" fill="#fff" />
    </svg>
  );
}

export function TikTokGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect width="24" height="24" rx="6" fill="#010101" />
      <path fill="#fff" d="M17.5 8.7a4.3 4.3 0 0 1-2.6-.9v4.9a3.9 3.9 0 1 1-3.9-3.9c.2 0 .4 0 .6.1v2a1.9 1.9 0 1 0 1.3 1.8V4.5h1.9a4.3 4.3 0 0 0 2.7 3.2z" />
      <path fill="#25F4EE" d="M16.9 8.1A4.3 4.3 0 0 1 15.9 5h-.4a4.3 4.3 0 0 0 1.4 3.1z" opacity=".8" />
    </svg>
  );
}

export function LinkedInGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect width="24" height="24" rx="5" fill="#0A66C2" />
      <path fill="#fff" d="M8.1 9.6H5.6V18h2.5V9.6zM6.8 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM18.4 18h-2.5v-4.1c0-1-.3-1.7-1.2-1.7-.7 0-1 .5-1.2.9-.1.2-.1.4-.1.7V18H9.9s.1-7.7 0-8.4h2.5v1.2c.3-.5.9-1.2 2.2-1.2 1.6 0 2.8 1 2.8 3.3V18z" />
    </svg>
  );
}

export function GoogleGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M23 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.2a5.3 5.3 0 0 1-2.3 3.5v2.9h3.7c2.2-2 3.4-5 3.4-8.6z" />
      <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.8-2.9l-3.7-2.9c-1 .7-2.4 1.1-4.1 1.1-3.1 0-5.8-2.1-6.7-5H1.4v3C3.3 21.3 7.3 24 12 24z" />
      <path fill="#FBBC05" d="M5.3 14.3a7.2 7.2 0 0 1 0-4.6v-3H1.4a12 12 0 0 0 0 10.6l3.9-3z" />
      <path fill="#EA4335" d="M12 4.8c1.8 0 3.3.6 4.6 1.8l3.4-3.4C17.9 1.2 15.2 0 12 0 7.3 0 3.3 2.7 1.4 6.7l3.9 3c.9-2.9 3.6-4.9 6.7-4.9z" />
    </svg>
  );
}
